module.exports = __webpack_public_path__ + "static/media/KER-NEW.ebc6a580.apng";